import React, { useEffect, useState } from 'react'
// import { jsPDF } from 'jspdf';
// import jsPDF from 'jspdf';

// import html2canvas from 'html2canvas';
import InspectionPdf from './InspectionPdf';
import list from "../assets/data/serviceChecklist.json"
import HeadPdf from './HeadPdf';
import HeadServiceForm from './HeadServiceForm';
import ClientForm from './ClientForm';
import Footer from './Footer';
// import CONSTANTS from '../CONSTANTS';
import API from '../methods/API';
import common from '../methods/common';
import apiControllers from '../methods/apiControllers';


// const MARGIN = 20;

const ServiceChecklist = () => {

    const [data, setData] = useState({})
    const [formdata, setFormData] = useState({})
    const [error, setError] = useState("");
    const [isSumitted, setSubmitted] = useState(false);
    const [isClientDone, setClientDone] = useState(false);
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        let obj = {};
        list.forEach(item => {
            obj[item.key] = {}
            obj[item.key]["displayName"] = item.value
            obj[item.key]["value"] = "Yes"
            obj[item.key]["images"] = []
        });
        setData(obj)
    }, [])


    const handleChange = (e) => {
        setError("")
        setData(prev => ({
            ...prev,
            [e.target.name]: { ...data[e.target.name], comment: data[e.target.name] && data[e.target.name].comment ? data[e.target.name].comment : "", value: e.target.value }
        }))
    }
    const updateData = (obj)=>{
        setFormData((prev)=>({...prev, ...obj}))
    }
    const clientFormSubmit=(bool)=>{
        setClientDone(bool)
        window.scrollTo(0,0)
    }


    const createScreenshotPDF = () => {
        let payload =  common.createPayloadForGoogleSheet(data, formdata, {})
        API.pushPlantServiceReportToDB(payload)
        setLoader(true)
        let body = apiControllers.getServicePayload(formdata,data);

        API.saveServiceReportAPI(body).then((res)=>{
            console.log(res)
        }).catch((err)=> console.log(err))

        const { jsPDF } = window.jspdf;

        let doc = new jsPDF('p', 'px', [842, 595]);
        let pdfjs = document.querySelector('#content');
        let date = new Date();
        let current_date = `_${date.getDate()}_${date.getMonth()+1}_${date.getFullYear()}`
        let name = `${formdata.companyName? formdata.companyName:""}` + current_date + "_Service_by_VACSPL.pdf"

        doc.html(pdfjs, {
            callback: function (doc) {
                setLoader(false);
                doc.save(name);
            },
            x: 0,
            y: 0
        });

    }


    const handleComment = (obj) => {
        setData(prev => ({ ...prev, [obj.key]: { ...data[obj.key], isBoxOpen: true } }))

    }
    const handleTextComment = (e) => {
        setData(prev => ({ ...prev, [e.target.name]: { ...data[e.target.name], comment: e.target.value } }))
    }
    const handleSave = (obj) => {
        setData(prev => ({ ...prev, [obj.key]: { ...data[obj.key], isBoxOpen: false } }))
    }
    const addImage = (e, item) => {

        setData(prev => ({ ...prev, [item.key]: { ...data[item.key], images: [...data[item.key].images, ...e.target.files] } }))
    }

    console.log(data)


    const renderInputFile = (item) => {
        return (
            <div className='comment mrgL20' >
                <label className='drop-container mb0'>
                    <input
                        type="file"
                        id={item.key}
                        name={item.key}
                        accept="image/*"
                        multiple
                        onChange={(e) => addImage(e, item)}
                        className=''
                    />
                    {/* <label for={item.key}>Select file</label> */}
                </label>
            </div>
        )
    }

    // if(loader){
    //     return <div className='wait'><div class="loader"></div><div><p>Kindly wait for 10 seconds. We are creating the report for you....</p></div></div>
    // }
    if (isSumitted) {
        return <div>
            <button class="danger black btn-round mr-1 btn button-4 btn-sm m25" outline size="lg" onClick={()=>setSubmitted(false)} type="button">Edit Inspection</button>
            <div id="content" className="content pdfContent">
                <HeadPdf formdata={formdata} />
                <InspectionPdf data={data} />
            </div>
            <button class="danger black btn-round mr-1 btn button-4 btn-sm m25" outline size="lg" onClick={createScreenshotPDF} type="button">Download Inspection</button>

        </div>
    }
    return (
        <div className='service-main ta-l' >
            {loader ?<div className='wait'><div class="loader"></div><div><p>Kindly wait for 10 seconds. We are creating the report for you....</p></div></div>:null}
            <HeadServiceForm />
            <ClientForm data={formdata} updateData={updateData} isClientDone={isClientDone} clientFormSubmit={clientFormSubmit}/>
           {isClientDone && <div className='checklistmain-top '>
            <div className='checklistmain '>
                <div className='padB20 main-heading'> Let's Start the inspection for the plant</div>
                <div className='main-heading'> Check List For Plant Visit</div>
                {!isSumitted && <div className='checklistCom'>
                    {list.map((item, i) => {
                        let isChecked = data[item.key] && data[item.key].value === "Yes"
                        return (
                            <div className='radio-con'>
                                <div className="typography-line pad-l0">
                                    <div>
                                        {/* <span className="note">Header 1</span> */}
                                        {i + 1}. {item.value}
                                    </div>
                                </div>
                                {/* <div className='check-head'>{i + 1}. {item.value}</div> */}
                                <div className='input-div d-flex'>
                                    <div className={`form-check-radio ${isChecked ? "greenC" : ""}`}>
                                        {/* <Label check="Yes"> */}
                                        <input
                                            defaultValue="Yes"
                                            id={item.key + "_1"}
                                            name={item.key}
                                            type="radio"
                                            onChange={handleChange}
                                            checked={isChecked}
                                        />
                                        This is Okay.<span className="form-check-sign" />
                                        {/* </Label> */}
                                    </div>
                                    <div className={`form-check-radio mar-l20 ${isChecked ? "" : "redC"}`}>
                                        {/* <Label check="No"> */}
                                        <input
                                            defaultValue="No"
                                            id={item.key + "_2"}
                                            name={item.key}
                                            type="radio"
                                            onChange={handleChange}
                                            checked={!isChecked}
                                        />
                                        Its Not Okay!! <span className="form-check-sign" />
                                        {/* </Label> */}
                                    </div>
                                </div>
                                {/* <input type="radio" id={item.key + "_1"} name={item.key} value={"Yes"} checked={data[item.key] && data[item.key].value === "Yes"} onChange={handleChange} />
                                    <label>Yes</label>
                                    <input type="radio" id={item.key + "_2"} name={item.key} value={"No"} checked={data[item.key] && data[item.key].value === "No"} onChange={handleChange} />
                                    <label>No</label> */}
                                <div className='d-flex pm10'>
                                    <button className="btn-round mr-1 btn button-4 btn-sm " color="info" outline type="button" onClick={() => handleComment(item)}>Add Comment</button>

                                    {/* {data[item.key] && !data[item.key].isBoxOpen && <div className='comment' onClick={() => handleComment(item)}><span>{data[item.key].comment ? "Edit Comment" : "Add Comment"}</span></div>} */}
                                    {renderInputFile(item)}
                                </div>

                                {data[item.key] && !data[item.key].isBoxOpen && data[item.key].comment && <div className='commenttxt'>* {data[item.key].comment}</div>}
                                {data[item.key] && data[item.key].isBoxOpen && <textarea id={item.key + "_textArea"} name={item.key} rows="4" cols="50" onChange={handleTextComment}>{data[item.key] && data[item.key].comment ? data[item.key].comment : ""}</textarea>}
                                {data[item.key] && data[item.key].isBoxOpen && <div className='comment' onClick={() => handleSave(item)}><button className='button-4'>Save Comment</button></div>}

                                <div className='image-group-service'>{data[item.key] && data[item.key].images ? data[item.key].images.map((imgFile) => {
                                    return <div className='uploadImg-main'><img src={URL.createObjectURL(imgFile)} alt='' className="upload-img" /></div>
                                }) : null}</div>
                            </div>
                        )
                    })}
                </div>}
                {error && <div className='error'>**{error}</div>}
                {isSumitted && <div className=''>The data has been saved. Wait, we are making the pdf...</div>}
                <div class="formSubmit">
                    <button color="btn-round mr-1 btn button-4 btn-sm " outline size="lg" onClick={() => setSubmitted(true)} type="button">Save Data</button>
                    {/* <button id="btn" className='btnn' onClick={handleSubmit}>
                        <p id="btnText">Submit</p>
                        <div class="checked">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50">
                                <path fill="transparent" d="M14.1 27.2l7.1 7.2 16.7-16.8"></path>
                            </svg>
                        </div>
                    </button> */}
                </div>

            </div>
            </div>}
            <Footer />
        </div>
    )
}

export default ServiceChecklist